import { api } from '@/shared/api/axios';

export interface Task {
  id: string;
  _id?: string;
  title: string;
  status: 'todo' | 'in_progress' | 'review' | 'done';
  due_date: string | null;
}

export interface TasksResponse {
  tasks: Task[];
}

export const fetchPendingTasks = async (): Promise<TasksResponse> => {
  const { data } = await api.get<TasksResponse>('/api/tasks');
  return data;
};
